import type { UtmParameters } from './types';

const UTM_STORAGE_KEY = 'diag_utm_params';

/**
 * Extrai parâmetros UTM e de campanha a partir de uma query string ou URL
 */
export function extractUtmParams(searchParams: URLSearchParams): UtmParameters {
  const params: UtmParameters = {};

  const keys: (keyof UtmParameters)[] = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'origem',
    'evento',
  ];

  for (const key of keys) {
    const value = searchParams.get(key);
    if (value && value.trim()) {
      params[key] = value.trim().slice(0, 100); // limita tamanho para segurança
    }
  }

  return params;
}

/**
 * Salva parâmetros UTM no sessionStorage do navegador de forma segura
 */
export function persistUtmParams(params: UtmParameters): void {
  try {
    if (typeof window === 'undefined') return;
    const existing = getPersistedUtmParams();
    const merged = { ...existing, ...params };
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(merged));
  } catch (err) {
    console.warn('Não foi possível persistir parâmetros UTM em sessionStorage', err);
  }
}

/**
 * Recupera os parâmetros UTM salvos durante a sessão
 */
export function getPersistedUtmParams(): UtmParameters {
  try {
    if (typeof window === 'undefined') return {};
    const item = sessionStorage.getItem(UTM_STORAGE_KEY);
    if (!item) return {};
    return JSON.parse(item) as UtmParameters;
  } catch {
    return {};
  }
}
